import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import { formatDate } from '../../../utils/parsers-formatters';
import {
  required,
  validInitialDate,
  validFinalDate,
} from '../../../utils/validators';
import { Col, Row } from './styles';

class OtherPeriodForm extends Component {
  render() {
    const { onChange } = this.props;

    return (
        <Row>
          <Col md6>
            <Field
              name="initialPeriod"
              format={formatDate}
              validate={[required, validInitialDate]}
              floatingLabelText="Data inicial"
              fullWidth
              props={{
                maxLength: 10,
              }}
              component={TextField}
              onChange={onChange}
            />
          </Col>
          <Col md6>
            <Field
              name="finalPeriod"
              fullWidth
              format={formatDate}
              validate={[required, validFinalDate]}
              floatingLabelText="Data final"
              props={{
                maxLength: 10,
              }}
              component={TextField}
              onChange={onChange}
            />
          </Col>
        </Row>
    );
  }
}

// redux

const mapStateToProps = (state, props) => ({
  initialValues: {
    initialPeriod: props.initialPeriod
      ? moment(props.initialPeriod).format('DD/MM/YYYY')
      : moment().subtract(30, 'day').format('DD/MM/YYYY'),
    finalPeriod: moment(props.finalPeriod).format('DD/MM/YYYY'),
  },
});

export default connect(mapStateToProps)(
  reduxForm({ form: 'deliveryOtherPeriodForm' })(OtherPeriodForm),
);
